export const calculateTotalConsom = (paymentRows, setPaymentRows) => {
    const updatedPaymentRows = [...paymentRows];  
    if(updatedPaymentRows && updatedPaymentRows.length > 0){
        updatedPaymentRows.forEach(row => {
            const quantiteConsom = row.quantiteConsom;
            const unitPriceConsom = row.unitPrice;
            if(quantiteConsom && unitPriceConsom){
                row.totalConsom = quantiteConsom * unitPriceConsom;
            }
        });
    }
    setPaymentRows([...updatedPaymentRows]);
};
